import { Container } from "@mui/system";
import { Grid, Typography, Paper, IconButton, Divider, Button } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from '@mui/material/Select';
import React from "react";
import { styled } from "@mui/material/styles";
import globals from "../globals";
import { formatEur } from "../utils";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingIcon from "../components/loading";

const RedButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.lightRed,
    '&:hover': {
        backgroundColor: globals.colors.darkRed,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

const BlueButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.darkBlue,
    '&:hover': {
        backgroundColor: globals.colors.lightBlue,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Cart = () => {
    const { cart, setCourseQuantity, removeFromCart, clearCart } = useCart();
    const { token } = useAuth();
    const navigate = useNavigate();

    const [numLessons, setNumLessons] = React.useState({});
    const [openDialog, setOpenDialog] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [intentURL, setIntentURL] = React.useState(null);

    const handleLessonChange = (courseId) => (event) => {
        const { value } = event.target;
        setNumLessons((prev) => ({
            ...prev,
            [courseId]: value, // store only one value for this course
        }));
    };

    const handleDelete = (courseId) => {
        removeFromCart(courseId);
    }

    const getLineTotal = (price, quantity) => Number(price) * (quantity || 1);

    const getCartTotal = () => Object.values(cart).reduce(
        (total, { course, quantity }) => total + getLineTotal(course.price, quantity),
        0,
    );

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const createPaymentIntent = () => {
        setLoading(true);
        const data = { courses: [] }
        for (const course of Object.values(cart)) {
            data.courses.push({ id: course.course.id, quantity: course.quantity });
        }
        data.currency = 'EUR';
        //console.log(data);
        
        fetch(`${globals.apiUrl}/courses/create-payment-intent`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //////console.log(data);
                if (data.url) {
                    setIntentURL(data.url);
                    handleClickOpen();
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });

    }


    return (
        <Container>
            <Grid container>
                <Grid item xs={12} style={{ padding: '20px' }}>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 40, fontWeight: 'bold', mb: 3 }}>Количка <ShoppingCartIcon sx={{ color: globals.colors.textColor }} /></Typography>
                    {Object.keys(cart).length === 0 ? (
                        <Grid container justifyContent="center" alignItems="center" spacing={2} textAlign={'center'}>
                            <Grid item>
                                <img src="cart_page_no_courses.webp" style={{ height: 400, width: 400 }} />
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mb: 2 }}>Пазарската ти количка за знания е празна...</Typography>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>Разгледай нашите онлайн курсове <a href='/courses' style={{ color: globals.colors.lightRed }}>тук.</a></Typography>

                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container spacing={6}>
                            <Grid item xs={12} sm={8}>
                                <Paper elevation={3}>
                                    <Grid>
                                        {Object.values(cart).map(({ course: course, quantity: quantity }, i) => (
                                            <Grid container key={course.id} sx={{ padding: 2, borderBottom: '1px solid #ccc' }} justifyContent={'center'} textAlign={'center'}>
                                                <Grid container alignContent={'center'} sx={{ mb: 1 }}>
                                                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mr: 5 }}>{i + 1}.</Typography>
              {/* {(name.length <= 33) ? name : name.slice(0, 30).concat('...')} */}
                                                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>{(course.title.length <= 40) ? course.title : course.title.slice(0, 37).concat("...")} / {course.instructor_name}</Typography>
                                                    <IconButton sx={{ color: globals.colors.textColor, cursor: 'pointer', ml: 'auto' }} onClick={() => handleDelete(course.id)}>
                                                        <DeleteOutlineIcon />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs={12} sm={5}>
                                                    <FormControl sx={{
                                                        m: 1, minWidth: 150, '& .MuiOutlinedInput-root': {
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: globals.colors.lightRed, // Focus border color
                                                            },
                                                        },
                                                    }}>
                                                        <Select
                                                            value={cart[course.id].quantity || ""}
                                                            onChange={(e) => setCourseQuantity(course, e.target.value)}
                                                            displayEmpty
                                                            inputProps={{ 'aria-label': 'Without label' }}
                                                        >
                                                            <MenuItem value="">
                                                                <em>Брой уроци</em>
                                                            </MenuItem>
                                                            <MenuItem value={1}>1</MenuItem>
                                                            <MenuItem value={2}>2</MenuItem>
                                                            <MenuItem value={3}>3</MenuItem>
                                                            <MenuItem value={4}>4</MenuItem>
                                                            <MenuItem value={5}>5</MenuItem>
                                                            <MenuItem value={6}>6</MenuItem>
                                                            <MenuItem value={8}>8</MenuItem>
                                                            <MenuItem value={9}>9</MenuItem>
                                                            <MenuItem value={10}>10</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={12} sm={7}>
                                                    <Typography sx={{ mt: 2, color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 17 }}>{formatEur(getLineTotal(course.price, cart[course.id].quantity))}</Typography>
                                                </Grid>

                                            </Grid>
                                        ))}
                                    </Grid>
                                    <Divider />

                                    <Grid container justifyContent={'center'} alignContent={'center'} sx={{ mt: 2 }} spacing={2}>
                                        <Grid item sx={12} sm={4}>
                                            <Typography sx={{ color: globals.colors.lightRed, fontSize: 17, fontWeight: 'bold' }}>Метод на плащане:</Typography>
                                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 15, fontWeight: 'bold' }}>Дебитна / кредитна карта</Typography>
                                        </Grid>

                                        <Grid item sx={12} sm={4}>
                                            <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 17 }}>Валута за плащане:</Typography>
                                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 15, fontWeight: 'bold' }}>Евро (EUR)</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} justifyContent={'center'} textAlign={'center'} sx={{ mt: 5 }}>
                                        <Grid item xs={12} sm={6}>
                                            <Grid container justifyContent={'center'} textAlign={'center'} sx={{ mt: 1 }}>
                                                <Grid item>
                                                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 20, fontWeight: 'bold', mr: 1 }}>Общо:</Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 19, fontWeight: 'bold' }}>{formatEur(getCartTotal())}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            {loading && <LoadingIcon sx={{ mr: 1 }} /> }
                                            <RedButton variant='contained' size="large" onClick={createPaymentIntent} sx={{ textTransform: 'capitalize', fontSize: 17, mb: 3, width: 170 }}>Плащане</RedButton>
                                            <Dialog
                                                open={openDialog}
                                                slots={{
                                                    transition: Transition,
                                                }}
                                                keepMounted
                                                onClose={handleClose}
                                                aria-describedby="alert-dialog-slide-description"
                                            >
                                                {/* <DialogTitle>{"Use Google's location service?"}</DialogTitle> */}
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-slide-description">
                                                        <Grid container justifyContent={'center'} textAlign={'text'}>
                                                            <Grid item>
                                                                <img src='popup_stripe.webp' width={150} height={170} />
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography sx={{ fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Ще бъдеш пренасочен към защитена външна страница за сигурно плащане.</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <BlueButton onClick={handleClose} sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, width: 120 }}>Откажи</BlueButton>
                                                    <RedButton
                                                        // component={Link}
                                                        // to={{ pathname: '/success', state: { title: 'Успешно плащане!' } }}
                                                        // href="/success"
                                                        onClick={() => {window.location.href = intentURL; clearCart()}}
                                                        sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, width: 120 }}>Продължи</RedButton>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>

                                </Paper>
                                <Paper elevation={3} sx={{ padding: 2, marginTop: 2 }}>
                                    <Grid container justifyContent="space-between" alignItems="center" xs={8} sm={12}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', pb: 1 }}>Продължи да разглеждаш курсове тук</Typography>
                                        <BlueButton variant="contained" href="/courses" sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, }}>Разгледай</BlueButton>
                                    </Grid>
                                </Paper>
                            </Grid>

                            {/* Promotions */}
                            <Grid item xs={12} sm={4} justifyContent={'center'} alignItems={'center'} textAlign={'center'}>
                                <Paper elevation={3} sx={{ height: '50vh' }}>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', py: 1 }}>Промоции</Typography>
                                    <Divider />
                                    <Typography sx={{ color: globals.colors.darkBlue, pt: 2, fontWeight: 'bold' }}>Няма активни промоции в момента.</Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Container >
    );
}

export default Cart;